//
//
//
//
//
//
//
//
//
//
//
import { throttle } from '@vip-activity/utils';
export default {
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    this.bindEvent();
  },
  methods: {
    bindEvent: function bindEvent() {
      var _this = this;

      var el = document.querySelector('.open-anchor');
      window.addEventListener('scroll', throttle(function () {
        if (!el) {
          return;
        }

        var rect = el.getBoundingClientRect();
        _this.isShow = rect.y <= 0;
      }));
    }
  }
};